/**
 * Confirm removal of cart line items before the theme's native cart handler
 * runs. Pointer and keyboard activation use the same accessible interaction.
 */
(function () {
  var SEL = '.cart-items__remove';

  /* Window capture fires before the theme's own document-capture
     handlers, whatever the registration order. */
  window.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(SEL);
    if (!btn) return;
    if (window.confirm('Remove this item from your cart?')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);
})();
